module.exports = __webpack_public_path__ + "img/scene-db.2ce7cf67.png";